/**
 * @Author: hangbale
 * @Date:   2017-05-30
 * @Email:  571312070@qq.com
 * @Last modified by:   hangbale
 * @Last modified time: 2017-09-07
 */



import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Hotlist from '@/components/Hotlist'
import Recommend from '@/components/Recommend'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 如果你的連結是帶 # 這種
    // to.hash 就會有值(值就是連結)
    // 例如 #3
    if (to.hash) {
      return {
        // 這個是透過 to.hash 的值來找到對應的元素
        // 照你的 html 來看是不用多加處理這樣就可以了
        // 例如你按下 #3 的連結，就會變成 querySelector('#3')，自然會找到 id = 3 的元素
        selector: to.hash
      }
    }
  },
  routes: [{
      path: '/',
      name: 'Main',
      component: Main
    },
    {
        path: '/hotlist',
        name: 'hotlist',
        component: Hotlist,
        beforeEnter: (to, from, next) => {
            if (window.innerWidth < 780) {
                next('/recommend')
            } else {
                next();
            }
        }
    },
    {
        path: '/recommend',
        name: 'recommend',
        component: Recommend
    }
  ]
});

// 设置路由拦截
// 在vue-router的全局钩子中设置拦截
// 每个路由皆会的钩子函数
// to 进入 from 离开 next 传递

router.beforeEach((to, from, next) => {
    let pageWidth = document.body.scrollWidth;
    if(to.name === 'hotlist' && pageWidth < 415) {
        next({
            path: '/recommend',
            name: 'recommend',
            component: Recommend
        })
    }else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js